const URL_RE = /(https?:\/\/[^\s<>"']+[^\s<>"'.,:;!?)\]}])/gi;

/**
 * Разбивает текст сообщения на токены для безопасного рендера.
 * HTML НЕ собирается строкой и не идёт в v-html — ссылки отдаются
 * отдельными токенами, шаблон рендерит их как <a> с текстовым содержимым.
 *
 * @returns {{type: 'text'|'link', value: string}[]}
 */
export function linkifyTokens(content) {
  const str = content == null ? '' : String(content);
  const tokens = [];
  let lastIndex = 0;
  let match;

  URL_RE.lastIndex = 0;
  while ((match = URL_RE.exec(str)) !== null) {
    if (match.index > lastIndex) {
      tokens.push({ type: 'text', value: str.slice(lastIndex, match.index) });
    }
    tokens.push({ type: 'link', value: match[0] });
    lastIndex = match.index + match[0].length;
    if (match[0].length === 0) URL_RE.lastIndex++;
  }
  if (lastIndex < str.length) {
    tokens.push({ type: 'text', value: str.slice(lastIndex) });
  }
  return tokens;
}

/** Инициалы для аватара: «Иванов Пётр» → «ИП». */
export function initials(name) {
  const parts = String(name == null ? '' : name)
    .trim()
    .split(/[\s,]+/)
    .filter(Boolean);
  if (!parts.length) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
